import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {isEmpty, get} from 'lodash';
import api from 'api';
import {downloadFromLink} from '../../utils/common';
import Button from 'components/Button';
import {Col} from './styled';
import Modal from 'components/Modal';
import PDFPreview from './PDFPreview';

type ContractModalTypes = {
  reservationId: string;
  housingId: string;
  isOpenModal: boolean;
  setIsOpenModal: any;
};

const ModalTitle = styled.div`
  font-size: 28px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  color: #23262f;
`;

const ModalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 28px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  color: #23262f;
`;

function ContractModal({
  reservationId,
  housingId,
  isOpenModal,
  setIsOpenModal,
}: ContractModalTypes) {
  // const {t} = useTranslation();
  const {t} = useTranslation();
  const handleDownloadButton = React.useCallback(async () => {
    if (!reservationId) {
      return;
    }

    const {data, error} = await api.documents.getContracts(
      `housing_sample_id=${housingId}`,
    );
    const contract = get(data, '0.file');

    if (contract) {
      downloadFromLink(contract);
    }

    if (error) {
      console.log('error', error);
    }
  }, [housingId, reservationId]);

  const handleCloseContractButton = () => {
    setIsOpenModal(!isOpenModal);
  };

  if (isEmpty(reservationId) || !isOpenModal) {
    return null;
  }

  return (
    <Modal
      open={isOpenModal}
      onClose={handleCloseContractButton}
      closeOnDocumentClick
      closeOnEscape
      withCloseButton
      contentStyle={{maxWidth: '550px', padding: '50px', borderRadius: '15px'}}
    >
      <Col>
        <ModalRow>
          <ModalTitle>{t('contract_preview')}</ModalTitle>
          <Button
            onClick={() => handleDownloadButton()}
            label={t('download')}
            blackButton
          />
        </ModalRow>
        <ModalRow style={{justifyContent: 'center', height: '485'}}>
          <PDFPreview housingId={housingId} />
        </ModalRow>
      </Col>
    </Modal>
  );
}

export default ContractModal;
